/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_DiscardInputs */

const cs_action_discard = /** @type {(inputs: Action_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahodit`)
};

const en_action_discard = /** @type {(inputs: Action_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Action_DiscardInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_discard = /** @type {((inputs?: Action_DiscardInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_DiscardInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_discard(inputs)
	return cs_action_discard(inputs)
});